import commonApi from './CommonApi.js';

export default {
	getAll: async (parameters) => {
		return await commonApi().get('/v1/admin/userDomainHistories/getAll', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getBatch: async (parameters) => {
		return await commonApi().get('/v1/admin/userDomainHistories/getBatch', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}